module.exports = __webpack_public_path__ + "img/ltkcyberweek-2x.7971470.jpg";